var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.727 0H2.961C1.328 0 0 1.29 0 2.875V20.13c0 1.586 1.328 2.875 2.96 2.875h8.885v-7.908H8.883v-3.592h2.962V8.626c0-2.382 1.988-4.313 4.44-4.313h2.962v3.595h-1.48c-.818 0-1.481-.074-1.481.718v2.877h3.7l-1.48 3.594h-2.219v7.907h4.441c1.634 0 2.962-1.288 2.962-2.875V2.875C23.69 1.29 22.36 0 20.727 0"
})));
export default SvgFacebook;